var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetaDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    height: 13,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    width: 24,
    height: 24,
    transform: "rotate(90 6.5 6.5)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.833 2.167H2.167v8.666",
    style: {
      fill: "none"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.833 2.167H2.167v8.666",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1
    },
    className: "stroke-shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m2.167 2.167 3.791 3.791",
    style: {
      fill: "none"
    },
    className: "fills"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.167 2.167 3.791 3.791",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 1
    },
    className: "stroke-shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaDiagonal);
export default __webpack_public_path__ + "static/media/seta-diagonal.927296fc7f84a764c4029e3b90dff284.svg";
export { ForwardRef as ReactComponent };